/**
 * API functions for account lockout status
 */

import { getSession, urlWithAdminQuery } from '@/auth';
import { createDefaultHeaders } from '@/api';

export interface AccountLockoutStatus {
  is_locked: boolean;
  account_status?: string;
  locked_at?: number;
  can_self_unlock?: boolean;
  amount_due_cents?: number;
  unpaid_invoice_ids?: string[];
}

/**
 * Get the current account lockout status for the authenticated user
 */
export const getAccountLockoutStatus = async (): Promise<AccountLockoutStatus> => {
  const session = await getSession();
  const ep = '/account/lockout-status';

  const response = await fetch(urlWithAdminQuery(ep, session.adminEmail), {
    method: 'GET',
    headers: createDefaultHeaders({
      authToken: session.idToken.toString(),
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch lockout status');
  }

  return response.json();
};
